import { useState } from "react";
import { loginUser } from "../../firebase";
import "./Login.css";

export default function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [lockoutTime, setLockoutTime] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (lockoutTime && Date.now() < lockoutTime) {
      const remainingSeconds = Math.ceil((lockoutTime - Date.now()) / 1000);
      setError(`Zbyt wiele prób. Odczekaj ${remainingSeconds} sekund`);
      return;
    }

    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 1000));

    const result = await loginUser(email, password);

    if (result.success) {
      setAttempts(0);
      setLockoutTime(null);
      onLoginSuccess(result.user);
    } else {
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);

      if (newAttempts >= 5) {
        setLockoutTime(Date.now() + 5 * 60 * 1000);
        setError("Zbyt wiele nieudanych prób. Spróbuj ponownie za 5 minut");
        setAttempts(0);
      } else {
        setError(`${result.error} (Pozostało prób: ${5 - newAttempts})`);
      }
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2 className="login-title">Logowanie do panelu administratora</h2>
        
        {error && <div className="login-error">{error}</div>}
        
        <input
          type="email"
          placeholder="Adres email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          required
          disabled={loading}
          autoComplete="off"
        />
        
        <input
          type="password"
          placeholder="Hasło"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
          required
          disabled={loading}
          autoComplete="off"
        />
        
        <button 
          type="submit" 
          className="login-button"
          disabled={loading}
        >
          {loading ? "Logowanie..." : "Zaloguj się"}
        </button>
      </form>
    </div>
  );
}